import I18n from 'lib/i18n'
import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import Slider from 'lib/components/slider'
import Course from './course'

export default function LatestCourses ({ courses, dpr, id = 'homepage-latest-classes' }) {
  return (
    <div id={id} className='latest-classes'>
      <div className='grid'>
        <div className='col-1-1'>
          <h2 className='homepage'>{I18n.t('react.homepage.recent_courses.title')}</h2>
        </div>
      </div>
      <div className='grid small-wide'>
        <Slider>
          {courses.map(course => (
            <Course key={course.id} width={150} course={course} dpr={dpr} />
          ))}
        </Slider>
      </div>
    </div>
  )
}

LatestCourses.propTypes = {
  courses: PropTypes.array,
  dpr: PropTypes.number,
  id: PropTypes.string
}
